module.exports = __webpack_public_path__ + "media/images/arrow-prev-94b545060a7e243c7d21c03af812c10e.svg";